module.exports = __webpack_public_path__ + "static/img/logo_slogan_pc_zh.a5c3f99.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/tryout/logo/logo_slogan_pc_zh.png
// module id = Oy5n
// module chunks = 34